<template>
  <noscript>
    <img height="1" width="1" style="display: none" src="https://www.facebook.com/tr?id=260461292012061&ev=PageView&noscript=1" />
  </noscript>

  <div v-if="loadSnigelDiv">
    <component is="script" data-cfasync="false" type="text/javascript"> var snigelPubConf = { adengine: { activeAdUnits: [], }, }; </component>

    <component is="script" async="" data-cfasync="false" :src="adScriptUrl" type="text/javascript"> </component>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, computed, watch, ref } from 'vue';
import { useRoute } from 'vue-router';
import { axiosClassic } from '@/services/axiosConfig';
import { useUserDataStore } from '@/store/userDataStore';

const userDataStore = useUserDataStore();
const route = useRoute(); // Vue router route object
const loadSnigelDiv = ref(false); // Load the snigel div only when the page is loaded
const adScriptUrl = import.meta.env.VITE_AD_SCRIPT_URL; // Import the ad script url from the global variables

const jsdefs = computed(() => {
  return userDataStore.jsdefs;
}); // jsdefs object

document.addEventListener('body_content_loaded', function () {
  if (jsdefs.value) {
    doSnigelAdAuction();
  }
});

watch(
  () => route.fullPath,
  () => {
    doSnigelAdAuction();
    sendpageview();
  },
);

watch(
  () => jsdefs.value,
  () => {
    userAdConsent();

    if (jsdefs.value) {
      doSnigelAdAuction();
    }
  },
);

onMounted(() => {
  loadSnigelDiv.value = true;
  loadGTM();
});

function sendpageview() {
  (window as any).gtag?.('event', 'page_view', {
    page_location: window.location.href,
    page_path: window.location.pathname,
    page_title: document.title,
  });

  (window as any).fbq?.('track', 'PageView');
}

// Load snigel with ad units from jsdefs
function doSnigelAdAuction() {
  var activeAdUnits = jsdefs.value.adUnits; // as an array

  //check activeadunits is not empty and is an array
  if (!Array.isArray(activeAdUnits) || activeAdUnits.length === 0) {
    return;
  }

  var no_ad_pages = jsdefs.value.noAdPages; // as an array
  if (no_ad_pages && no_ad_pages.some((x: string) => route.fullPath.includes(x))) {
    return;
  }

  if ((window as any).adngin && (window as any).adngin.adnginLoaderReady) {
    // when adnginLoaderReady boolean is true, it is safe to access command queues like adngin.queue or googletag.queue
    (window as any).adngin.queue.push(() => {
      // it is recommended to auction only ONCE, so please gather all required ad unit names;
      // or do not pass anything if all ad units are to be re-auctioned
      (window as any).adngin.cmd.startAuction(activeAdUnits);
      console.log('Snigel ad auction started');
      console.log(activeAdUnits);
    });
  }
}

function loadFaceBookPixel() {
  loadScript('https://connect.facebook.net/en_US/fbevents.js');

  (window as any).fbq?.('init', 260461292012061);
}

function loadGTM() {
  (window as any).dataLayer = (window as any).dataLayer || [];

  loadScript('https://www.googletagmanager.com/gtm.js?id=' + jsdefs.value.ga4Tag);

  function gtag(p0?: string, ga4Tag?: any, g?: any) {
    (window as any).dataLayer.push(arguments);
  }

  (window as any).gtag = gtag;

  gtag('js', new Date());
  gtag('config', jsdefs.value.ga4Tag);
  gtag('event', 'user_metrics', {
    testgroup: jsdefs.value.gaTestGroup,
    emailgroup: jsdefs.value.emailTestGroup,
  });
  gtag('consent', 'default', {
    'analytics_storage': 'denied',
    'wait_for_update': 1500
  });

}

function userAdConsent() {
  try {
    window.addEventListener('adconsentReady', function () {
      (window as any).adconsent?.('getConsent', null, function (consent: { fullConsent: any }, success: any) {
        if (success) {
          if (consent.fullConsent) {
            // If user has consented to ads, update consent on ga and Facebook Pixel
            (window as any).gtag('consent', 'update', { analytics_storage: 'granted' });
            loadFaceBookPixel();
          } else {
            // User denied consent
          }

          // Update user config if consent has changed
          if (consent.fullConsent != jsdefs.value.userAdconsent) {
            updateAdconsent(jsdefs.value.personId, consent.fullConsent);
          }
        }
      });
    });
  } catch (error) {
    console.log(error);
  }
}

function updateAdconsent(personID: string, consent: string) {
  axiosClassic
    .get('config?action=update_config&type=adverts&personid=' + personID + '&adconsent=' + consent + '&key=' + jsdefs.value.commsKey)
    .then((response) => {
      // console.log(response);
    })
    .catch((error) => {
      console.log(error);
    });
}

function loadScript(url: string) {
  const script = document.createElement('script');
  script.src = url;
  script.type = 'text/javascript';
  document.head.appendChild(script);
}
</script>

<style lang="scss"></style>
